import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import i18n from 'i18next'
import * as R from 'ramda'

import PageRouting from '../../PageRouting'
import Modal from '../../../UniformComponents/Modal'
import PanelAccordion from '../../../UniformComponents/PanelAccordion'
import Select from '../../form/Select'
import SkipDisplayLogic from '../../SkipLogic/SkipDisplayLogic'
import QuotaSkipLogic from '../../SkipLogic/QuotaSkipLogic'
import Button from '../../../UniformComponents/Button'

import './styles/SkipLogicModal.scss'
import { trackBuilderLogicEdit } from '../../../utils/MixpanelManager'

@observer
class SkipLogicModal extends Component {
    @observable displaySectionOpen = false

    @observable pageSectionOpen = false

    @observable hasUnsavedChanges = false

    targetPage

    togglePageSection = () => {
        this.pageSectionOpen = !this.pageSectionOpen
    }

    toggleDisplaySection = () => {
        this.displaySectionOpen = !this.displaySectionOpen
    }

    hideSkipLogicModal = () => {
        const { store } = this.props

        if (store.hasUnsavedSkipLogic) {
            store.openUnsavedSkipLogicModal(this.previousSkipLogic)
            return
        }

        store.skipLogicModalVisible = false
        store.skipLogicModalData = {
            page: null,
            pageId: null,
        }
        this.previousSkipLogic = undefined
    }

    getRoutingPages = (currIndex) => {
        const { store } = this.props
        const { survey } = store
        let index = 0
        const pages = [
            ...survey.pages.reduce((arr, surveyPage) => {
                if (currIndex < index) {
                    arr.push({ value: surveyPage.id, label: `${i18n.t('s_page')}: ${surveyPage.priority} ${(surveyPage.title ? (` - ${surveyPage.title}`) : '')}` })
                }
                index += 1
                return arr
            }, []),
        ]

        return pages
    }

    getRouting = () => {
        const { store } = this.props
        const { skipLogicConfig: { page }, survey } = store

        if (!page) return

        let label = i18n.t('form.general.please_select_ellipsis')
        let value = 0
        const skipToPage = store.survey.skipLogic.find((sl) => (sl.action.kind === 'PageToPage' && sl.trigger.condition.pageId === page.id))
        if (skipToPage) {
            const targetPage = survey.pages.find((p) => p.id === skipToPage.action.pageId)
            if (targetPage && targetPage.priority > page.priority) {
                label = `${i18n.t('s_page')}: ${targetPage.priority} ${(targetPage.title ? (` - ${targetPage.title}`) : '')}`
                value = targetPage.id
            } else {
                label = 'Invalid SkipLogic -- remove'
                value = '-1'
            }
        }

        this.targetPage = {
            label,
            value,
        }
    }

    setPageRouting = (obj) => {
        const { store } = this.props
        this.targetPage = obj
        store.handleUnsavedSkipLogicChanges()
    }

    save = () => {
        const { store } = this.props
        const { skipLogicConfig: { page } } = store
        let skipLogic

        const existingSkipLogic = store.survey.skipLogic.find((sl) => (sl.action.kind === 'PageToPage' && sl.trigger.condition.pageId === page.id))

        if (existingSkipLogic && R.isNil(this.targetPage.value)) {
            trackBuilderLogicEdit(store, { action: 'delete', type: 'page', logic_type: 'routing', source: 'menu' })
            existingSkipLogic.pageRemoved(page, store)
            store.hasUnsavedSkipLogic = false
            return
        }

        if (existingSkipLogic) {
            try {
                trackBuilderLogicEdit(store, { action: 'add/edit', type: 'page', logic_type: 'routing', source: 'menu' })
                existingSkipLogic.action.pageId = this.targetPage.value
                skipLogic = existingSkipLogic
            } catch (e) {
                console.error(e)
                store.addNotification(null, i18n.t('skipLogicModal.errorSaving'), 'error')
            }
        } else {
            trackBuilderLogicEdit(store, { action: 'add/edit', type: 'page', logic_type: 'routing', source: 'menu' })
            const newSkipLogic = store.survey.newPageToPage(page.id, this.targetPage.value)
            skipLogic = newSkipLogic
        }

        skipLogic.save(store)
        store.hasUnsavedSkipLogic = false
    }

    getModalTitle = (type) => {
        switch (type) {
            case 'page':
                return i18n.t('skipLogicModal.pageSkipTitle')
            case 'question':
                return i18n.t('skipLogicModal.questionSkipTitle')
            case 'option':
                return i18n.t('skipLogicModal.optionSkipTitle')
            default:
                return ''
        }
    }

    render() {
        const { store } = this.props
        const { skipLogicConfig } = store
        const {
            page, pageIndex, question, type,
        } = skipLogicConfig
        const routing = this.getRoutingPages(pageIndex)
        this.getRouting()
        const pageHasPageLogic = store.survey.skipLogic.find((sl) => (sl.action.kind === 'PageToPage' && R.pathOr(null, ['trigger', 'condition', 'pageId'], sl) === R.pathOr('', ['id'], page)))
        // Maybe we don't want the below line, it finds if the page contains questions that have SkipToPage logic, therefore showing Edit logic, even if the page doesn't have page routing.
        const pageContainsQuestionsPageLogic = page ? page.questions.find((pq) => store.survey.skipLogic.find((sl) => sl.action.kind === 'SkipToPage' && R.pathOr(null, ['triggerGroups', 0, 'children', 0, 'triggers', 0, 'condition', 'pageQuestionId'], sl) === R.pathOr('', ['id'], pq))) : false
        const questionHasPageLogic = store.survey.skipLogic.find((sl) => (sl.action.kind === 'SkipToPage' && R.pathOr(null, ['triggerGroups', 0, 'children', 0, 'triggers', 0, 'condition', 'pageQuestionId'], sl) === R.pathOr('', ['id'], question)))
        const pageHasQuestionLogic = store.survey.skipLogic.find((sl) => (sl.action.kind === 'SkipToPage' && sl.action.pageId === R.pathOr('', ['id'], page)))
        const questionHasShowLogic = store.survey.skipLogic.find((sl) => (sl.action.kind === 'ShowQuestion' && sl.action.pageQuestionId === R.pathOr('', ['id'], question)))
        const optionHasShowLogic = R.pathOr([], ['question', 'skipLogic'], skipLogicConfig).find((sl) => (sl.action.kind === 'ShowQuestionOption' && sl.action.optionId === R.pathOr(null, ['option', 'id'], skipLogicConfig)))
        const pageHasShowLogic = store.survey.skipLogic.find((sl) => sl.action.kind === 'ShowPage' && R.pathOr(null, ['page', 'id'], skipLogicConfig) === sl.action.pageId)
        const title = this.getModalTitle(type)
        const showQuotas = store.survey.metadata.allowQuotas
        const displaySkipLogicHasRules = type === 'page' ? pageHasShowLogic : type === 'option' ? optionHasShowLogic : questionHasShowLogic
        const pageSkipLogicHasRules = type === 'page' ? pageHasPageLogic || pageContainsQuestionsPageLogic : questionHasPageLogic
        const pageLogicButtonText = pageSkipLogicHasRules ? i18n.t('skipLogicModal.editLogic') : i18n.t('skipLogicModal.addLogic')
        const displayLogicButtonText = displaySkipLogicHasRules ? i18n.t('skipLogicModal.editLogic') : i18n.t('skipLogicModal.addLogic')
        const showDisplayLogic = (type === 'question' && !question.isHidden) || type === 'page' || type === 'option'
        const showQuotaLogic = (type === 'question' && !question.isHidden) || type === 'page'
        let description
        let pageLogicDescription = 'skipLogicModal.pageSkipDescriptionQuestion'

        if (type === 'page') {
            description = 'skipLogicModal.displaySkipLogicDescriptionPage'
            pageLogicDescription = 'skipLogicModal.pageSkipDescriptionPage'
        } else if (type === 'question') {
            description = 'skipLogicModal.displaySkipLogicDescriptionQuestion'
        } else {
            description = 'skipLogicModal.displaySkipLogicDescriptionOption'
        }

        return (
            <Modal
                show={store.skipLogicModalVisible}
                onClose={this.hideSkipLogicModal}
                style={{ width: 1100 }}
            >
                <h2>{title}</h2>

                <p>{i18n.t('skipLogicModal.modalDescription', { type })}</p>

                <br />

                <br />

                {showDisplayLogic
                    ? (
                        <Fragment>
                            <PanelAccordion
                                title={i18n.t('skipLogicModal.displaySkipLogic')}
                                description={i18n.t(description)}
                                ctaLabel={displayLogicButtonText}
                                hasRules={displaySkipLogicHasRules}
                            >
                                <SkipDisplayLogic
                                    pages={store.survey.pages}
                                    store={store}
                                    onUnsavedChange={this.handleUnsavedChanges}
                                    handleSaveChanges={this.handleSaveChanges}
                                    {...this.props}
                                />
                            </PanelAccordion>

                            <br />

                            <br />
                        </Fragment>
                    ) : null}

                {type !== 'option'
                    ? (
                        <PanelAccordion
                            title={i18n.t('skipLogicModal.pageSkipLogic')}
                            description={i18n.t(pageLogicDescription)}
                            ctaLabel={pageLogicButtonText}
                            hasRules={pageSkipLogicHasRules}
                        >
                            <Fragment>
                                {type === 'page'
                                    ? (
                                        <Fragment>
                                            <div className="skip-logic-page-table">
                                                <div className="skip-logic-page-table-header">
                                                    <p>{i18n.t('skipLogicModal.pageSkipLogicInputDescription')}</p>
                                                </div>

                                                <div className="skip-logic-page-table-content">
                                                    <Select
                                                        label={i18n.t('skipLogicModal.pageRoute')}
                                                        options={routing}
                                                        defaultValue={this.targetPage ? this.targetPage.value : null}
                                                        onBlur={this.setPageRouting}
                                                        isClearable
                                                        blurOnClear
                                                    />
                                                </div>
                                            </div>

                                            <br />
                                        </Fragment>
                                    ) : null}

                                <PageRouting pages={store.survey.pages} store={store} {...this.props} />

                                {type === 'page'
                                    ? (
                                        <Fragment>
                                            <br />

                                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                                <Button
                                                    label={i18n.t('skipLogicModal.saveLogic')}
                                                    icon="fal fa-save"
                                                    onClick={this.save}
                                                    cssClass="primary regular"
                                                />
                                            </div>
                                        </Fragment>
                                    ) : null}
                            </Fragment>
                        </PanelAccordion>
                    ) : null}

                <br />

                <br />

                {showQuotas && showQuotaLogic
                    ? <QuotaSkipLogic store={store} pageIndex={pageIndex} />
                    : null}
            </Modal>
        )
    }
}

export default SkipLogicModal
